import { render, staticRenderFns } from "./TopParallax.vue?vue&type=template&id=568cc94a&"
import script from "./TopParallax.vue?vue&type=script&lang=js&"
export * from "./TopParallax.vue?vue&type=script&lang=js&"
import style0 from "./TopParallax.vue?vue&type=style&index=0&id=568cc94a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports